const config = {
  applyTypeMap: { 0: '正常流程', 1: '修改流程', 2: '撤销流程' },
  taskExecModeMap: { 1: '依次审批', 2: '会签', '-2': '会签（全部通过）', 3: '或签', '-3': '或签（任意一人通过）', 4: '自动通过', 5: '自动拒绝' },
  auditResultMap: { 0: '未开始', 1: '审批中', 2: '已通过', 3: '已拒绝', 4: '已抄送', 5: '已撤回', 6: '已撤销', 7: '已修改', 8: '已撤销修改', 9: '退回至审批人', 10: '已打回', 11: '自动通过', 12: '自动拒绝', 13: '已转交', 14: '已加签', 15: '已评论', 98: '去除重复', 99: '不需要执行' },
  taskStatusMap: { 0: '未开始', 1: '审批中', 2: '审核通过', 3: '审核不通过', 4: '已抄送', 5: '撤回', 6: '撤销', 7: '修改撤销', 8: '回退', 9: '回退到申请人', 10: '自动通过', 11: '自动拒绝' }
};
export { config };
